import { render } from "./BarChartGainLoss.vue?vue&type=template&id=1ed53000&scoped=true"
import script from "./BarChartGainLoss.vue?vue&type=script&lang=js"
export * from "./BarChartGainLoss.vue?vue&type=script&lang=js"

import "./BarChartGainLoss.vue?vue&type=style&index=0&id=1ed53000&lang=scss&scoped=true"

import exportComponent from "/builds/retina-v5/principal-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed53000"]])

export default __exports__